import { render, staticRenderFns } from "./EmailBrochureForm.vue?vue&type=template&id=5cd2f6b4&scoped=true&"
import script from "./EmailBrochureForm.vue?vue&type=script&lang=js&"
export * from "./EmailBrochureForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailBrochureForm.vue?vue&type=style&index=0&id=5cd2f6b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd2f6b4",
  null
  
)

export default component.exports